<template>
  <AsyncPage :loader="useMyPortalLoader" :page-component="MyPortal" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useMyPortalLoader } from "./MyPortal.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const MyPortal = defineAsyncComponent(() => import("./MyPortal.vue"));
</script>
